"use strict";
import { TooltipManager as tooltipManager } from "../../js/helpers/tooltipmanager";

ui.loadTemplateFile("buffbar.html");

// STATEICON.png: 20px cells on a 21px stride, 12 per row (see STATEICON.TSI).
const STATE_ICON_CELL = 21;
const STATE_ICON_COLS = 12;
const STATE_ICON_SCALE = 1.3; // 20px -> 26px, a bit smaller than 40px skill slots
const STATUS_COL_SYMBOL = 9; // LIST_STATUS.STB icon index into STATEICON

function formatRemaining(ms: number) {
    const s = Math.max(0, Math.ceil(ms / 1000));
    const m = Math.floor(s / 60);
    return m > 0 ? `${m}m ${s % 60}s` : `${s}s`;
}

class BuffBarDialog extends Dialog {
    _element: any;
    _anchor: any;
    _hovered: { buff: any; x: number; y: number } | null;

    // Floats directly below `anchor` (the character status panel).
    constructor(anchor: any) {
        super("buffbar.html");
        this._anchor = anchor._element;
        this._hovered = null;

        new ResizeObserver(() => this._position()).observe(this._anchor[0]);
        setInterval(() => this._refreshTooltip(), 250);

        MC.buffs.on("changed", this._update.bind(this));
        this._update();
    }

    _position() {
        const pos = this._anchor.position();
        this._element.css({
            left: pos.left + "px",
            top: pos.top + this._anchor.outerHeight() + 4 + "px",
        });
    }

    _tooltip(buff: any) {
        const name = GDM.getNow("skill_data").getName(buff.skillIdx);
        const left = buff.startedAt + buff.durationMs - Date.now();
        return $('<div><div class="skill name"></div><div class="buff-remaining"></div></div>')
            .find(".name").text(name).end()
            .find(".buff-remaining").text("Remaining: " + formatRemaining(left)).end();
    }

    _refreshTooltip() {
        const h = this._hovered;
        if (h) {
            tooltipManager.showTooltip(this._tooltip(h.buff), h.x, h.y);
        }
    }

    _update() {
        this._element.empty();
        if (this._hovered) {
            this._hovered = null;
            tooltipManager.hideTooltip();
        }

        const statusData = GDM.getNow("list_status");
        for (const buff of MC.buffs.getActive()) {
            const iconId = Number(statusData.row(buff.statusEffectId)[STATUS_COL_SYMBOL]) || 0;
            const x = (iconId % STATE_ICON_COLS) * STATE_ICON_CELL * STATE_ICON_SCALE;
            const y = Math.floor(iconId / STATE_ICON_COLS) * STATE_ICON_CELL * STATE_ICON_SCALE;
            const icon = $('<div class="buff-icon" />')
                .css("background-position", `${-x}px ${-y}px`)
                .on("mousemove", (e: any) => {
                    this._hovered = { buff, x: e.clientX, y: e.clientY };
                    this._refreshTooltip();
                })
                .on("mouseout", () => {
                    this._hovered = null;
                    tooltipManager.hideTooltip();
                });
            this._element.append(icon);
        }
        this._position();
    }
}

ui.BuffBarDialog = BuffBarDialog;

ui.buffBarDialog = function (anchor: any) {
    return new BuffBarDialog(anchor);
};
